module.exports = __webpack_public_path__ + "static/media/iii-ambientworks.05759df.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/iii-ambientworks.mp3
// module id = +F40
// module chunks = 0